import { API_ROUTES, HTTP_METHODS, PAGE_SIZE } from '@Utils/constants';
import { sendCall } from '@Utils/request.utils';

const { ASSET_TYPE } = API_ROUTES;

class AssetTypeService {
  createAssetType = (params: unknown) =>
    sendCall(ASSET_TYPE.POST, {
      data: params,
      method: HTTP_METHODS.POST,
    });

  updateAssetType = (id: string | undefined, params: unknown) =>
    sendCall(`${ASSET_TYPE.PUT}/${id}`, { data: params, method: HTTP_METHODS.PUT });

  getAssetTypes = (page: number | null, pagination: boolean) =>
    sendCall(`${ASSET_TYPE.GET}?page=${page}&limit=${PAGE_SIZE}&pagination=${pagination}`, {
      method: HTTP_METHODS.GET,
    });

  disableAssetType = (id: string | undefined) => sendCall(`${ASSET_TYPE.DISABLE}/${id}`, { method: HTTP_METHODS.POST });

  searchAssetType = (params: unknown, page: number) =>
    sendCall(`${ASSET_TYPE.SEARCH_POST}?page=${page}&limit=${PAGE_SIZE}`, {
      data: params,
      method: HTTP_METHODS.POST,
    });
}

export default new AssetTypeService();
